import React, { useState } from "react";
import { FaX } from "react-icons/fa6";
import useEventState from "../../hooks/eventHooks";
import { IoPencilSharp } from "react-icons/io5";

function EditEvent({ event, setIsEditEventModalOpen, editEvent, updateEvent }) {
  const getFileName = (poster) => {
    const res = poster.split("/");
    return res[res.length - 1];
  };

  const [eventEdit, setEventEdit] = useState({
    name: editEvent.name,
    edition: editEvent.edition,
    poster: editEvent.poster,
    whatsapp_url: editEvent.whatsapp_url,
  });

  const handleChange = (e) => {
    if (e.target.name === "poster") {
      setEventEdit({ ...eventEdit, [e.target.name]: e.target.files[0] });
    } else {
      setEventEdit({ ...eventEdit, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, edition, poster, whatsapp_url } = eventEdit;
    if (poster === editEvent.poster) {
      updateEvent({ name, edition, whatsapp_url }, editEvent.id);
    } else {
      updateEvent({ name, edition, whatsapp_url, poster }, editEvent.id);
    }
    setIsEditEventModalOpen(false);
  };
  return (
    <div className="bg-bg-modal fixed w-screen h-screen top-0 left-0 overflow-hidden z-20">
      <div className="lg:w-4/12 w-11/12 lg:h-3/5 h-4/5 m-auto bg-white lg;mt-28 mt-8 rounded-xl relative">
        <div className="flex justify-between items-center p-3">
          <h3 className="text-xl capitalize">Edit Event</h3>
          <FaX
            onClick={() => {
              setIsEditEventModalOpen(false);
            }}
            className="hover:cursor-pointer"
          />
        </div>
        <form onSubmit={handleSubmit}>
          {/* inputs */}
          <div className="p-6">
            <div className="flex flex-col">
              <label htmlFor="name" className="mb-1">
                Event Name
              </label>
              <input
                id="name"
                name="name"
                value={eventEdit.name}
                onChange={handleChange}
                className="border border-gray-70 rounded-lg h-10 w-72 p-2"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="edition" className="mb-1">
                Edition
              </label>
              <input
                id="edition"
                type="text"
                name="edition"
                onChange={handleChange}
                value={eventEdit.edition}
                className="border border-gray-70 rounded-lg h-10 w-72 p-2"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="edition" className="mb-1">
                Whatsapp Link
              </label>
              <input
                id="whatsapp_url"
                type="url"
                name="whatsapp_url"
                onChange={handleChange}
                value={eventEdit.whatsapp_url}
                className="border border-gray-70 rounded-lg h-10 w-72 p-2"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="poster">
                <p>Change Poster</p>
                <div className="border border-gray-70 p-2 rounded-lg hover:cursor-pointer mt-1 flex justify-between items-center">
                  <p>
                    {eventEdit.poster.name
                      ? eventEdit.poster.name
                      : getFileName(eventEdit.poster)}
                  </p>
                  <IoPencilSharp />
                </div>
              </label>
              <input
                onChange={handleChange}
                placeholder="chage Poster"
                id="poster"
                name="poster"
                accept="image/png, image/jpeg"
                type="file"
                className="hidden"
              />
            </div>
          </div>
          <div className="w-full flex gap-1 items-end absolute bottom-0 p-2">
            <button
              onClick={() => {
                setIsEditEventModalOpen(false);
              }}
              className="bg-red-50 w-1/2 h-14 text-white capitalize flex justify-center items-center rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-green-50 w-1/2 h-14 text-white capitalize flex justify-center items-center rounded-lg"
            >
              Edit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditEvent;
